import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Text } from '../../components/Text';
import Hint from '../../components/ModuleDrawer/Hint';
import { LoadingBar } from '../../components/util/LoadingBar';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SliderControl } from '../../components/controls/NewSliderControl';
import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';
import { currencyFormatter } from '../../components/Money';

export const STEP_SIZE = 250;
export const EXPENDITURE_FACTOR = 0.8;

class CurrentExpenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentExpenses: props.qna_hash.currentExpenses
        ? props.qna_hash.currentExpenses.answer
        : `${this.calcDefaultAmount(props)}`,
    };
  }

  calcDefaultAmount = props => {
    let incomeYearly = parseInt(props.qna_hash.primaryBase.answer);
    if (props.qna_hash.hasPartner.answer) {
      incomeYearly += parseInt(props.qna_hash.partnerBase.answer);
    }

    return Math.round(incomeYearly * EXPENDITURE_FACTOR / 12 / STEP_SIZE) * STEP_SIZE;
  };

  componentDidMount() {
    this.props.pathAware('currentExpenses');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.currentExpenses) {
      this.setState({
        currentExpenses: props.qna_hash.currentExpenses.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        currentExpenses: {
          question: 'What will your living expenses be in retirement?',
          answer: this.state.currentExpenses,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = evt => {
    this.setState({ currentExpenses: evt.detail.value });
  };

  render() {
    const { qna_hash, wrapper } = this.props;
    const { currentExpenses } = this.state;

    if (!qna_hash.primaryBase) {
      return <LoadingBar />;
    }

    let incomeYearly = parseInt(qna_hash.primaryBase.answer);
    if (qna_hash.hasPartner.answer) {
      incomeYearly += parseInt(qna_hash.partnerBase.answer);
    }

    // round max monthly expenses in dollars to the nearest $`STEP_SIZE`, currently $250
    const maxExpensesMonthly = Math.round(incomeYearly * 1.3 / 12 / STEP_SIZE) * STEP_SIZE;
    const minExpensesMonthly = Math.round(incomeYearly * 0.4 / 12 / STEP_SIZE) * STEP_SIZE;

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later.</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What are your current monthly living expenses?</Text>
        </div>
        <div style={{ width: '100%' }}>
          <Text use="body1" className="ml-4 mr-4">
            The typical household spends about 70% of their pre-tax income, with the rest going to savings or taxes.
          </Text>
        </div>
        <div style={{ width: '80%' }}>
          <SliderControl
            id="currentExpenses"
            spec={{
              field_type: 'range',
              min: minExpensesMonthly,
              max: maxExpensesMonthly,
              step_size: STEP_SIZE,
              _default: 3000,
            }}
            onChange={this.onChange}
            onInput={this.onChange}
            value={currentExpenses}
          />
        </div>
        <Text use="subtitle1">
          Monthly Expenses: <span style={{ fontWeight: 500 }}>{currencyFormatter(currentExpenses)}</span>
        </Text>
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(CurrentExpenses);
